<!-- 功能定义 - 数据定义 -->
<template>
<div>
  <Table
    ref="table"
    :loadObj='{}'
    :option="{}"
    :colObj='{
      opId:"105",
      name:"数据定义",
      parentId:"OP_ID",
      parentName:"功能定义",
      parentPath:"/system/function",
      dataClass:2,
      col:[]
    }'
  >
  </Table>
  <el-dialog :visible.sync="functionDialog" :append-to-body="true" custom-class="dialogStyle" width="90%" top="1vh" :title="select.title" :close-on-click-modal="false">
    <Selector ref="ConSelector" v-if="functionDialog" :select="select" @listenEvent="fn"></Selector>
  </el-dialog>
</div>
</template>

<script>
import Table from '@/components/table/dataTablecSon';
import Selector from '@/components/table/selectorc';
import {processDeal} from '@/api/home/home';
export default {
  components: {
    Table,
    Selector,
  },
  data() {
    return {
      firstEnter:true,
      functionDialog:false,
      select:{
        title:"请选择功能",
        searchslotId:"108",
        searchslotkey:{"ID":"ID"},
        searchslotType:"add",
        multiple:false,
        filter:"",
      },
    };
  },
  computed: {
  },
  methods: {
    // 维护按钮
    maintainBtnRowClick(btn,row){
      this.$router.push({
        path:'/system/functionSonSon',
        query:{
          runId:this.$route.query.runId,
          OP_ID:this.$route.query.OP_ID,
          DATA_CLASS:row.DATA_CLASS,
          sname:row.DATA_CLASS,
          pname:this.$route.query.sname,
        }
      })
    },
    generateBtnRowClick(btn,row){
      this.functionDialog=true;
    },
    // 获取选择器数据
    fn(param){
      this.functionDialog=false;
      if(param.ID.length===0) return;
      processDeal({obj:JSON.stringify({id:9,oldopid:param.ID[0],opid:this.$route.query.OP_ID})}).then(res=>{
        this.$refs.table.$refs.child.onLoad();
        this.$message.success("生成成功!");
      },err=>{})
    },
    generateTableClick(){
      processDeal({obj:JSON.stringify({id:9,oldopid:0,opid:this.$route.query.OP_ID})}).then(res=>{
        this.$refs.table.$refs.child.onLoad();
        this.$message.success("生成成功!");
      },err=>{})
    }
  },
  created(){
  },
  activated(){
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
